const PLATFORM_SYMBOL_MAP: Record<string, string> = {
  ios: "i",
  android: "a",
};

const SYMBOL_PLATFORM_MAP: Record<string, string> = {
  i: "ios",
  a: "android",
};

export { PLATFORM_SYMBOL_MAP, SYMBOL_PLATFORM_MAP };
